const TIME_WITH_MERIDIEM = /^(\d{1,2})(?::(\d{2}))?\s*([ap]m)$/i;
const TIME_24_HOUR = /^(\d{1,2}):(\d{2})$/;

export function parseTimeOfDay(text: string): number | null {
    const trimmed = text.trim();

    const meridiemMatch = trimmed.match(TIME_WITH_MERIDIEM);
    if (meridiemMatch) {
        const [, hourText, minuteText = '0', meridiem] = meridiemMatch;
        const hour = Number(hourText);
        const minute = Number(minuteText);
        if (hour < 1 || hour > 12 || minute > 59) return null;

        const hour24 = meridiem.toLowerCase() === 'pm' ? (hour % 12) + 12 : hour % 12;
        return hour24 * 60 + minute;
    }

    const militaryMatch = trimmed.match(TIME_24_HOUR);
    if (militaryMatch) {
        const [, hourText, minuteText] = militaryMatch;
        const hour = Number(hourText);
        const minute = Number(minuteText);
        if (hour > 23 || minute > 59) return null;

        return hour * 60 + minute;
    }

    return null;
}
